import { type DesignElementBase } from "..";
import { createIcon } from "../design-element-utils";

const designElement: DesignElementBase = {
  tags: ["neon-pixel", "neonpixel", "neon pixel"],
  iconColor: "#C825A8", // venus
  getIcon(options) {
    return createIcon(
      `
        <rect x="6" y="6" width="3.31034" height="3.31034" fill="#E356B6" />
        <rect x="9.3103" y="9.31055" width="8.68966" height="8.68966" fill="#E356B6" />
        <path
          d="M11.1724 11.1719V16.1374H12.1837V12.7103L15.0851 16.1374H16.1379V11.1719H15.0851V14.5268L12.2666 11.1719H11.1724Z"
          fill="white" />
      `,
      "#F9E9F6", // venus-2
      options?.borderColor || "#E0E2E6",
      options?.size || "24",
    );
  },
};

export default designElement;
